import { Card, CardContent, CardHeader, Tooltip, Typography } from '@mui/material';
import { isValidElement, ReactNode } from 'react';
import Row from '../../../../components/Row';
import { HelpOutlineOutlined } from '@mui/icons-material';

export function HatDbChartCard(props: { children: ReactNode; title?: string | ReactNode; tooltip?: string }) {
    const { children, title, tooltip } = props;

    return (
        <Card
            variant="outlined"
            sx={{
                overflow: 'visible',
                height: '100%',
            }}
        >
            {title && (
                <CardHeader
                    title={
                        <Row gap={0.5} alignItems="center">
                            {isValidElement(title) ? (
                                title
                            ) : (
                                <Typography variant="body1" color="text.secondary">
                                    {title}
                                </Typography>
                            )}

                            {tooltip && (
                                <Tooltip title={tooltip}>
                                    <HelpOutlineOutlined color="action" sx={{ fontSize: 16 }} />
                                </Tooltip>
                            )}
                        </Row>
                    }
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                />
            )}

            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    justifyContent: 'stretch',
                    flexWrap: 'wrap',
                    overflow: 'hidden',
                    paddingBottom: 2,
                    height: '100%',
                }}
            >
                {children}
            </CardContent>
        </Card>
    );
}
